import { render, staticRenderFns } from "./orderModal.vue?vue&type=template&id=5f8ae3cc"
import script from "./orderModal.vue?vue&type=script&lang=js"
export * from "./orderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports